export enum ButtonSizes {
  mini = 'mini',
  small = 'small',
  large = 'large',
}

export enum LSTButtonModes {
  instead = '1',
  above = '2',
}
export enum LiveTranslationButtons {
  flag = 'flag',
  earth = 'earth',
  characters = 'characters',
}

export const liveTranslationButtons = [
  {
    id: LiveTranslationButtons.flag,
    name: 'lt_icon_flag',
    ariaLabel: 'flag icon',
    size: 0,
  },
  {
    id: LiveTranslationButtons.characters,
    name: 'lt_icon_translation',
    ariaLabel: 'translation icon',
    size: 0,
  },
  {
    id: LiveTranslationButtons.earth,
    name: 'lt_icon_globe',
    ariaLabel: 'globe icon',
    size: 0,
  },
];

export const widgetButtons = [
  {
    id: 1,
    name: 'stMan',
    size: 0,
    ariaLabel: 'standing man icon',
  },
  {
    id: 2,
    name: 'wheelchair',
    size: 0,
    ariaLabel: 'icon of man in a wheelchair',
  },
  {
    id: 3,
    name: 'eyeIcon',
    size: 0,
    ariaLabel: 'icon eye disability',
  },
  {
    id: 6,
    name: 'walkMan',
    size: 0,
    ariaLabel: 'icon of man with walking stick',
  },
  {
    id: 5,
    name: 'sliders',
    size: 0,
    ariaLabel: 'icon of accessibility settings',
  },
  {
    id: 4,
    name: 'textBtn',
    width: 0,
    height: 0,
    ariaLabel: 'icon of accessibility text',
  },
];

export const widgetPosition = [
  {
    position: 'top-left',
    positionNumber: 7,
  },
  {
    position: 'top-center',
    positionNumber: 8,
  },
  {
    position: 'top-right',
    positionNumber: 1,
  },
  {
    position: 'mid-left',
    positionNumber: 6,
  },
  {
    position: 'mid-right',
    positionNumber: 2,
  },
  {
    position: 'bottom-left',
    positionNumber: 5,
  },
  {
    position: 'bottom-center',
    positionNumber: 4,
  },
  {
    position: 'bottom-right',
    positionNumber: 3,
  },
];

export const buttonsSizeList = [
  {
    sizeName: ButtonSizes.mini,
    width: 32,
    textButtonWidth: 87,
    textButtonHeight: 31,
  },
  {
    sizeName: ButtonSizes.small,
    width: 44,
    textButtonWidth: 120,
    textButtonHeight: 43,
  },
  {
    sizeName: ButtonSizes.large,
    width: 64,
    textButtonWidth: 124,
    textButtonHeight: 64,
  },
];

export const widgetPositionMobile = [
  {
    position: 'top-left',
    positionNumber: 7,
  },
  {
    position: 'top-right',
    positionNumber: 1,
  },
  {
    position: 'mid-left',
    positionNumber: 6,
  },
  {
    position: 'mid-right',
    positionNumber: 2,
  },
  {
    position: 'bottom-left',
    positionNumber: 5,
  },
  {
    position: 'bottom-right',
    positionNumber: 3,
  },
];
